module.exports = __webpack_public_path__ + "static/media/CuramLife.334d9b6a.webp";